import { render, staticRenderFns } from "./YearAmount.vue?vue&type=template&id=16f77e61&scoped=true&"
import script from "./YearAmount.vue?vue&type=script&lang=js&"
export * from "./YearAmount.vue?vue&type=script&lang=js&"
import style0 from "./YearAmount.vue?vue&type=style&index=0&id=16f77e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f77e61",
  null
  
)

export default component.exports